import React from "react";
// import { SRLWrapper } from "simple-react-lightbox";
import img1 from "../../assets/robiya.jpg";
import style from "./MainSingleProject.module.css";
import { useTranslation } from "react-i18next";
import { AccessTime, LiveTv, People } from "@material-ui/icons";
import { NavLink } from "react-router-dom";


export const RobiyaSingleProject = ({open}) => {
  const { t } = useTranslation();
   const map=[
    {id:1, img:img1,title:"Frontend course", title2:"Frontend course", text:t("robiya.name2"),sum1:2000000, sum2:1000000, sum3:300000, sum4:200000}
  ]
  const click=()=>{
    open(false)
  }
   const map2 =map.map(a=> 
   <NavLink to="/lesson" onClick={click}  key={a.id}> <div className={style.Sher}>
   

  
    <img src={a.img} alt="" />
    <div className={style.Course_Name}>
      <p>{a.title}</p>
      <h2>{a.title2}</h2>
      <div className={style.Sher_coursee}>
        <h3>
        <AccessTime style={{fontSize:"16px"}}/>
        Lifetime Access
        </h3>
        <h3><LiveTv style={{fontSize:"16px"}}/> 40 Lessons</h3>
        <h3><People style={{fontSize:"16px"}}/> 500 student</h3>
        
      </div>
      <h5>{a.text}</h5>
      <h6>{t("sher.education")}:<b>  {a.sum1} {t("sher.maney")} </b><span>{a.sum2} {t("sher.maney")}</span>  </h6>
      <h6>{t("sher.education2")}: <b>{a.sum3}{t("sher.maney")}</b><span>{a.sum4} {t("sher.maney")}</span>  </h6>
    </div>
  </div>  </NavLink>)

  return (
    <div className={style.lavhalar}>
      <h1>{t("sher.about")}</h1>
      <p>{t("robiya.about")} </p>
      <ul>
        <li>{t("sher.username")}: {t("robiya.Name")} </li>
        <li>
          {t("age")}: 18{" "}
        </li>
        <li>
          {t("sher.experience")} : {t("robiya.experience")}
        </li>
        <li>
         {t("sher.number")} : {t("robiya.number2")}
        </li>
      </ul>
      {map2}
    </div>
  );
};
